import { SpartenType, TaasJhpData, TaasTarifrisikoschluesselJHP } from '@ps20/bff-models';
import { convertJhpTaasBausteinToTarifrisikoschluessel } from '@ps20-frontend/frontend-models';
import { buildBasicSalesProductsForStrecke, parseDatum } from '@ps20-frontend/preis-lib';
import { IAppState } from '../../appState';

export function buildTaasJhpDataForStrecke(jhpState: IAppState): TaasJhpData {
  const taasJhpData = generateBasicTaasJhpData(jhpState);
  taasJhpData.salesProducts['SMART'] = [
    {
      schluessel: TaasTarifrisikoschluesselJHP.JHP,
      ausgewaehlt: true,
      isGefahr: true,
      isInklusiv: false,
    },
  ];
  taasJhpData.salesProducts['KOMFORT'] = [
    {
      schluessel: TaasTarifrisikoschluesselJHP.JHP,
      ausgewaehlt: true,
      isGefahr: true,
      isInklusiv: false,
    },
  ];
  return taasJhpData;
}

export function buildTaasJhpDataForShop(state: IAppState): TaasJhpData {
  const produktlinie = state.produkt.produktlinien.find(produktlinie => produktlinie.selected);
  const taasJhpData = generateBasicTaasJhpData(state);
  taasJhpData.salesProducts = {};
  taasJhpData.salesProducts[produktlinie.produktName.toUpperCase()] = [
    {
      schluessel: TaasTarifrisikoschluesselJHP.JHP,
      ausgewaehlt: true,
      isGefahr: true,
      isInklusiv: false,
    },
  ];
  return taasJhpData;
}

function generateBasicTaasJhpData(state: IAppState): TaasJhpData {
  return {
    spartenType: SpartenType.JAGDHAFTPFLICHT,
    geburtsdatumVN: parseDatum(state.versicherungsnehmer.geburtsdatum),
    znErhrisiko: state.taasInfo.specialInfo.erhrisiko,
    znAktionsnachlass: state.taasInfo.specialInfo.aktionsnachlass,
    znNachlman: state.taasInfo.specialInfo.nachlman,
    znZuschlman: state.taasInfo.specialInfo.zuschlman,
    salesProducts: buildBasicSalesProductsForStrecke(
      state.produkt,
      convertJhpTaasBausteinToTarifrisikoschluessel,
    ),
  };
}
